import { Dialog } from "primereact/dialog"
import React from "react"
import useTerminologiaRecorrencia from "../../../hooks/useTerminologiaRecorrencia";

function FAQAdimplenciaDialog({close}){
    const terminologia = useTerminologiaRecorrencia();
    const header = (<h3><b>Boleto Inteligente - Informações ao Usuário</b></h3>)

    return(
        <Dialog
        header={header}
        onHide={()=>close()}
        maximizable={true}
        style={{
            width:window.innerWidth < 640 ? '100vw' : "80vw",
            overflowY:'scroll'
        }}
        visible
        >
            <div>
                <p>O Boleto Inteligente ou sistema de adimplência é uma ferramenta para realizar o lançamento
                    de cobranças recorrentes na plataforma, para começar a utilizar é necessário em
                    primeiro lugar realizar a configuração dos parâmetros que pode ser feita clicando em
                    parâmetros.
                </p> <br/>
                <h4><b>Descrição dos botões</b></h4><br/>
                <h5># Parâmetros</h5>
                <p>O botão de parâmetros permite configurar os padrões de cobrança recorrentes, lá
                    será possível configurar taxas de juros e multas, tempo para fechamento das faturas
                    e prazo para pagamento.
                </p><br/>
                <p>Tambem será possível configurar os tipos de recebível que seriam a descrição do que será
                    cobrado de forma recorrente e criar {terminologia.labelGrupos.toLowerCase()} do credor para os quais a
                    cobrança recorrente será destinada.
                </p><br/>
                <h5># Contratos</h5>
                <p>Nesta página será possível adicionar cobranças recorrentes para os clientes desejados,
                    e excluir os que ja não possuem mais ontrato com o credor, assim como na opção de adicionar
                    recebíveis é possível adicionar cobranças extras para os contratos desejados usando o
                    botão de ações.
                </p><br/>
                <h5># Boletos</h5>
                <p>Página destinada a visualização dos boletos gerados para os clientes contratantes do serviço.
                    Nela é possível ver todos os boletos gerados para cobranças recorrentes e checar quais foram
                    vencidos.
                </p><br/>
                <h4><b>Relatórios</b></h4>
                <p>Aqui é possível gerar relatórios de acordo com uma faixa de tempo sobre os boletos em
                    .xlsx ou .pdf
                </p>
            </div>
        </Dialog>
    )
}

export default FAQAdimplenciaDialog
